module.exports = __webpack_public_path__ + "media/empty-states/sessions-2x-f9735670.png";